module.exports = __webpack_public_path__ + "./docs/img/big-icon-module.020a153745fdb2d24ee482425802da2b.svg";